/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConnectRequest = {
  code: string;
  state: string;
};

/** @internal */
export const ConnectRequest$inboundSchema: z.ZodType<
  ConnectRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  state: z.string(),
});
/** @internal */
export type ConnectRequest$Outbound = {
  code: string;
  state: string;
};

/** @internal */
export const ConnectRequest$outboundSchema: z.ZodType<
  ConnectRequest$Outbound,
  z.ZodTypeDef,
  ConnectRequest
> = z.object({
  code: z.string(),
  state: z.string(),
});

export function connectRequestToJSON(connectRequest: ConnectRequest): string {
  return JSON.stringify(ConnectRequest$outboundSchema.parse(connectRequest));
}
export function connectRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConnectRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectRequest' from JSON`,
  );
}
